import React, { useEffect, useRef, useState, useCallback } from 'react';
import useApp from 'hooks/useApp'
import { Logo, NoData, InfiniteScroll } from 'components'
import styles from '../index.module.css'
import Lib from 'library'
import { useRecoilState, useSetRecoilState } from 'recoil'
import useCommonIndustry from 'hooks/useCommonIndustry'
import DetailLayer from './DetailLayer'
import FilterLayer from './FilterLayer'
import { searchState, showDetailLayerState } from './states'
import { useNavigate } from 'react-router-dom'


const DataReceipt = ({ pageType, show, win }) => {

	const App = useApp()
	const navigate = useNavigate()
	const mounted = useRef()
	const [receipts, setReceipts] = useState()
	const [showFilterLayer, setShowFilterLayer] = useState(false)
	const industries = useCommonIndustry()
	const setShowDetailLayer = useSetRecoilState(showDetailLayerState)
	const [searchParam, setSearchParam] = useRecoilState(searchState)
	const pageNo = useRef(1)
	const noMore = useRef(false)
	const searchBar = useRef()

	let lastDate = null
	let list = null

	const openFilter = () => {
		setShowFilterLayer(true)
	}

	const closeFilter = () => {
		setShowFilterLayer(false)
		pageNo.current = 1
		noMore.current = false
		getData()
	}

	const goDetail = id => {
		setShowDetailLayer({
			show: true,
			id: id
		})
	}

	const getData = () => {
		if (noMore.current) return
		Lib.get("/api/more/data/rcpt", {
			stDe: searchParam.stDe,
			edDe: searchParam.edDe,
			indstCd: searchParam.industry,
			rcptTpCd: searchParam.type,
			rowsPerPage: 10,
			pageNo: pageNo.current
		}, data => {
			if (data.length < 1) {
				if (pageNo.current === 1) {
				    SetReceipts(null)
					noMore.current = false
				} else {
					noMore.current = true
				}
			} else {
				SetReceipts(data)
				pageNo.current = pageNo.current + 1
			}
		})
	}

	const SetReceipts = (data) => {
		const newList = []
		if (data) {
            data.map(row => {
                let found = newList.find(item => {
                    return row.useDe === item.useDe
                })
                if (!found) {
                    found = {
                        useDe: row.useDe,
                        data: []
                    }
                    newList.push(found)
                }
                found.data.push(row)
            })
		}
		setReceipts(prev => {
			if (!prev || pageNo.current === 1) {
				return newList
			} else {
				return [
					...prev,
					...newList
				]
			}
		})
	}

	const scrollBinding = e => {
        let core
		if (pageType === "layer") {
			core = win.current.firstElementChild
		} else {
			core = document.querySelector(".core")
		}
        if (core.scrollTop >= 100) {
            searchBar.current.style.paddingTop = 0
            searchBar.current.children[1].classList.remove("mt_20")
        } else {
            searchBar.current.style.paddingTop = "20px"
            searchBar.current.children[1].classList.add("mt_20")
        }
    }

	const bindScroll = () => {
		let core
		if (pageType === "layer") {
			core = win.current.firstElementChild
		} else {
			core = document.querySelector(".core")
		}
		if (!core.getAttribute("binded")) {
			core.setAttribute("binded", true)
			core.addEventListener("scroll", scrollBinding)
		}
	}

	useEffect(() => {
		if (typeof searchParam.period !== "undefined") {
			// [종료일자 기준으로 시작일자 보정. 20221019]
			let tempDe = new Date()
			let stDe
			const edDe = Lib.dateFormat(tempDe)
			switch (searchParam.period) {
				case 1:
					tempDe.setFullYear(tempDe.getFullYear() - 1)
					tempDe.setDate(tempDe.getDate() + 1)
					stDe = Lib.dateFormat(tempDe)
					break
				case 3:
					tempDe.setMonth(tempDe.getMonth() - 3)
					tempDe.setDate(tempDe.getDate() + 1)
					stDe = Lib.dateFormat(tempDe)
					break
				case 6:
					tempDe.setMonth(tempDe.getMonth() - 6)
					tempDe.setDate(tempDe.getDate() + 1)
					stDe = Lib.dateFormat(tempDe)
					break
				case 0:
					stDe = searchParam.stDe
					break
			}
			setSearchParam(prev => {
				console.log({ prev })
				return {
					...prev,
					stDe: stDe,
					edDe: edDe
				}
			})
		}
	}, [searchParam.period])

	useEffect(() => {
		mounted.current = true
		if (pageType !== "layer") {
			App.setHeader({
				show: true,
				title: <></>,
				left: <i className="icon_arrow_back" onClick={() => {
						navigate("/mydata")
				}} />,
				right: undefined,
				className: "translucent"
			})

			App.setShowNav(false)
			App.setMainClass("white")
			mounted.current && getData()
		}

		bindScroll()

		return () => {
			mounted.current = false
			let core
			if (pageType === "layer") {
				core = win.current?.firstElementChild
			} else {
				core = document.querySelector(".core")
			}
			if (core) {
				core.removeEventListener("scroll", scrollBinding)
				core.removeAttribute("binded")
			}
		}
	}, [])

	useEffect(() => {
		show && getData()
	}, [show])

	return (
		<div className="page">
			<div ref={searchBar} className="padding">
				<div className={styles["manage-title"]}>데이터 영수증</div>
				<div className="filter-group mt_20" style={{ transition: "margin 0.3s" }}>
					<div onClick={openFilter}>
						<span>{Lib.dateFormat(searchParam.stDe, ".")} ~ {Lib.dateFormat(searchParam.edDe, ".")}∙{(() => {
							switch (searchParam.type) {
								case "":
									return "전체"
								case "CLCT":
									return "수집"
								case "CHNG":
									return "변경"
								case "EXPND":
									return "연장"
								case "WTHDR":
									return "연동해제"
								case "DEL":
									return "삭제"
							}
						})()}∙{(() => {
							if (searchParam.industry === "") {
								return "전체"
							} else {
								if (!industries) return
								return industries.find(item => item.commCd === searchParam.industry).commNm
							}
						})()}</span>
						<i className="icon icon_filter ml_5" />
					</div>
				</div>
			</div>
			{
				receipts ?
					(
						<ul className="check-area padding">
							{
								receipts.length > 0 ?
									receipts.map((row, index) => {
                                        if(lastDate != row.useDe || lastDate == null) {
                                            lastDate = row.useDe
                                            return (
                                                <li key={index}>
                                                    <div className="check-date">{Lib.dateFormatKorean(Lib.ChanageNewDate(row.useDe))}</div>
                                                    <div className="check-list">
                                                        {
                                                            row.data.map((item, index) => {
                                                                return (
                                                                    <div key={index} onClick={() => goDetail(item.rcptId)} className={index % 2 ? "altRow" : undefined}>
                                                                        <div>
                                                                            <div className="img-box img-symbol">
                                                                                <Logo code={item.insttCd} style={{ width: "100%", height: "100%" }} />
                                                                            </div>
                                                                            <p className="ml_10 ellipsis" style={{ width: "17rem" }}>{item.insttNm}</p>
                                                                        </div>
                                                                        <div>
                                                                            <span className={`connect mr_10${item.rcptTpNm === "연결해제" ? " fail" : ""}`}>{item.rcptTpNm}</span>
                                                                            <i className="icon icon_arrow_sm right" />
                                                                        </div>
                                                                    </div>

                                                                )
                                                            })
                                                        }
                                                    </div>
                                                </li>
                                            )
                                        }
                                        else {
                                            lastDate = row.useDe
                                            return (
                                                <li key={index}>
                                                    <div className="check-list" style={{ marginTop: "-3rem" }}>
                                                        {
                                                            row.data.map((item, index) => {
                                                                return (
                                                                    <div key={index} onClick={() => goDetail(item.rcptId)} className={index % 2 ? "altRow" : undefined}>
                                                                        <div>
                                                                            <div className="img-box img-symbol">
                                                                                <Logo code={item.insttCd} style={{ width: "100%", height: "100%" }} />
                                                                            </div>
                                                                            <p className="ml_10 ellipsis" style={{ width: "17rem" }}>{item.insttNm}</p>
                                                                        </div>
                                                                        <div>
                                                                            <span className={`connect mr_10${item.rcptTpNm === "연결해제" ? " fail" : ""}`}>{item.rcptTpNm}</span>
                                                                            <i className="icon icon_arrow_sm right" />
                                                                        </div>
                                                                    </div>

                                                                )
                                                            })
                                                        }
                                                    </div>
                                                </li>
                                            )
                                       }
									})
									:
									<NoData tag="li" text="모은 데이터 영수증이 없네요." sub="마이데이터를 연결하고<br />이용할 때마다 영수증이 발급돼요." />
							}
							<InfiniteScroll callback={getData} />
						</ul>

					)
					:
					<div className="padding">
						{
							[...Array(3)].map((item, index) => {
								return (
									<React.Fragment key={index}>
										<div className={`skeleton ${index > 0 ? "mt_40" : ""}`} style={{ width: "10rem" }} />
										<div className="flex-justify_between mt_20">
											<div className="flex-align_center">
												<div className="skeleton" style={{ width: "3.4rem", height: "3.4rem", borderRadius: "50%" }} />
												<div className="skeleton ml_10" style={{ width: "10rem" }} />
											</div>
											<div className="flex-align_center">
												<span className="skeleton" style={{ width: "5rem" }} />
												<span className="skeleton ml_10" style={{ width: "1.8rem" }} />
											</div>
										</div>
									</React.Fragment>
								)
							})
						}
					</div>
			}

			<FilterLayer show={showFilterLayer} closeLayer={closeFilter} period={[
				{ key: "1년", value: 1 },
				{ key: "6개월", value: 6 },
				{ key: "3개월", value: 3 },
				{ key: "직접설정", value: 0 },
			]} />

			<DetailLayer />
		</div >
	)
}

export default DataReceipt